import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { VIOLATIONS_TAB_DETAILS_INITIAL_FILTERS } from '../../../shared/constants';
import { useInvertedLocalize } from '../../../shared/hooks';
import { type AdvancedFilterState } from '../../../shared/types';
import { detailsActions } from '../data-store/detailsSlice';

const useFiltersInitialization = () => {
  const l = useInvertedLocalize();
  const dispatch = useDispatch();

  const initializeFilters = useCallback(() => {
    const initialFilters: AdvancedFilterState[] = Object.values(
      VIOLATIONS_TAB_DETAILS_INITIAL_FILTERS
    ).map((filter) => ({
      ...filter,
      label: l(filter.label),
      options: filter.options?.map((option) => ({
        ...option,
        label: l(option.label),
      })),
    }));

    dispatch(detailsActions.setViolationsTabFilters(initialFilters));
  }, [l, dispatch]);

  useEffect(() => {
    initializeFilters();
  }, [initializeFilters]);
};

// eslint-disable-next-line import/prefer-default-export
export { useFiltersInitialization };
